import { useEffect, useState } from 'react';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  Flex,
  RemoteImage,
  useScreenSize,
  ScrollView,
} from '@banhala/ui-kit';
import { Image } from 'react-native';
import { isNotNil } from 'shared/src/utils';

export const useDeliveryTypeTodayInfoBottomSheet = createUseBottomSheetModal<
  void,
  { iconUrl: string | null; guideImageUrl: string | null }
>(({ confirm, param }) => {
  const { width: screenWidth } = useScreenSize();
  const imageWidth = screenWidth;

  const [imageHeight, setImageHeight] = useState(0);

  useEffect(() => {
    if (isNotNil(param.guideImageUrl)) {
      Image.getSize(param.guideImageUrl, (width, height) => {
        setImageHeight(Math.round(height * (imageWidth / width)));
      });
    }
  }, [param.guideImageUrl, imageWidth]);

  return (
    <BottomSheetContainer
      bottomDocked={{
        paired: false,
        button: {
          title: '닫기',
          outline: true,
          onPress: confirm,
        },
      }}
    >
      <ScrollView style={{ height: '80%' }}>
        <Flex width={imageWidth} height={imageHeight}>
          {isNotNil(param.guideImageUrl) && imageHeight > 0 && (
            <RemoteImage
              uri={param.guideImageUrl}
              width={imageWidth}
              // aspectRatio={1.4}
              height={imageHeight}
            />
          )}
        </Flex>
      </ScrollView>
    </BottomSheetContainer>
  );
});
